<dgx-modal
  [canCancel]="false"
  [canCloseHeader]="false"
  [isSubmitDisabled]="!isPolicyAccepted"
  [submitButtonText]="i18n.DataPrivacyModalCtrl_AcceptContinue"
>
  <ng-container class="modal-header"
    ><span tabindex="0">{{
      i18n.DataPrivacyModalCtrl_Header
    }}</span></ng-container
  >

  <ng-container class="modal-body">
    <div class="guts-p-full-1">
      <p
        [textContent]="i18n.DataPrivacyModalCtrl_PolicyReviewLabel"
        class="guts-m-b-1 font-semibold"
      ></p>

      <!--Privacy policy-->
      <div class="guts-p-full-1 scrollable border rounded legal--copy">
        <!--Policy message-->
        <div [innerHtml]="privacyMessage"></div>
        <!--When this scrolls into view, set the policy as "read"-->
        <div
          dgxIntersectionObserver
          (onIntersection)="allowPolicyAcception()"
        ></div>
        <button
          *ngIf="!isPolicyRead"
          class="a11y-hide"
          data-dgat="data-privacy-modal-816"
          (focus)="allowPolicyAcception(); focusCheckBox()"
        >
          {{ 'Core_Continue' | translate }}
        </button>
      </div>

      <!--Accept policy checkbox-->
      <label
        class="guts-m-t-1 block form-wrap__strong-checkbox"
        [ngClass]="{ 'cursor-pointer': isPolicyRead }"
        #dataPolicyReadCheckbox
      >
        <div class="font-medium l_flex l_flex-middle">
          <input
            type="checkbox"
            [disabled]="!isPolicyRead"
            [(ngModel)]="isPolicyAccepted"
            data-dgat="data-privacy-modal-04c"
          />
          <span
            class="guts-m-l-half"
            [textContent]="i18n.DataPrivacyModalCtrl_PolicyAcceptLabel"
          ></span>
        </div>
      </label>
    </div>
  </ng-container>
</dgx-modal>
